export default __webpack_public_path__ + "e1270cc484f5b68bac1f359a36bfecbb.svg";